module.exports = __webpack_public_path__ + "img/647-639874.png";